module.exports = __webpack_public_path__ + "c86584c.woff";